<template>
  <div :class="{ requiredLabel: required }">
    <v-autocomplete
      outlined
      dense
      hide-selected
      clearable
      small-chips
      open-on-clear
      multiple
      persistent-hint
      @change="resetSearchText"
      item-value="value"
      item-text="text"
      no-data-text="データが見つかりません。"
      :filter="filterItems"
      :search-input.sync="searchItem"
      v-on="$listeners"
      v-bind="$attrs"
      @input="(v) => $emit('input', v)"
    >
      <template v-slot:no-data>
        <v-list-item>
          <strong>「{{ searchItem }}」</strong>に一致する結果はありません。
        </v-list-item>
      </template>
      <template v-slot:selection="{ attrs, item, parent, selected }">
        <v-chip
          v-if="item === Object(item)"
          v-bind="attrs"
          color="lighten-3"
          class="mt-1 mb-1 pt-0 pb-0"
          :input-value="selected"
          small
          label
        >
          <span style="width: 100px" class="pr-2">{{
            (item.text && item.text.length) > 8
              ? item.text.substr(0, 8) + "..."
              : item.text
          }}</span>
          <v-icon small @click="parent.selectItem(item)">$delete</v-icon>
        </v-chip>
        <v-chip v-else color="lighten-3" dark label small>
          <span class="pr-2">{{ item }}</span>
          <v-icon small @click="parent.selectItem(item)">$delete</v-icon>
        </v-chip>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false,
    },
  },
  name: "CustomAutocompleteMulti",
  data() {
    return {
      searchItem: "",
    };
  },
  methods: {
    filterItems: function (item, queryText, itemText) {
      if (queryText) {
        queryText = queryText.trim();
      }
      return (
        itemText.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      );
    },
    resetSearchText() {
      this.searchItem = null;
    },
  },
};
</script>

<style lang="scss">
.requiredLabel label {
  &:after {
    font-weight: bold;
    content: " *";
    color: #ff5252;
    font-size: 17px;
  }
}
</style>
